import DragSourceWrapperWithDropzonesContainer from '../../../containers/dnd/DragSourceWrapperWithDropzonesContainer'

const ListDragItems = ({
    listId, 
    type = false, 
    dndType = false,

    order, 
    items, 
    selected = false,

    ChildSwitchItem,

    params = false,
    basicUrl=  false,

    canEdit = false,
    canDelete = false,
    deleteItem = false
}) => (
    order.map((itemId, index) => {
        const itemData = items.hasOwnProperty(itemId) ? items[itemId] : false
        const isSelected = selected ? selected.includes(itemId) : false

        if(!itemData) {
            return ''
        }

        return (
            <li key={index} className="item-drag">
                <DragSourceWrapperWithDropzonesContainer
                    index={index}
                    id={itemId}
                    type={type}
                    listId={listId}
                    dndType={dndType ? dndType : type}
                >
                    <ChildSwitchItem
                        itemId={itemId}
                        itemType={type}
                        itemData={itemData}
                        params={params}
                        basicUrl={basicUrl}
                        isSelected={isSelected}
                        canEdit={canEdit}
                        canDelete={canDelete}
                        deleteItem={deleteItem}
                    />
                </DragSourceWrapperWithDropzonesContainer>
            </li>
        )
    }
))

export default ListDragItems